import { AccountAndValue } from './components/AccountAndValue';
import { SummaryAndTokenValidation } from './components/SummaryAndTokenValidation';

export const withdrawalSteps = {
  accountAndValue: AccountAndValue,
  summaryAndTokenValidation: SummaryAndTokenValidation,
};
